import React from 'react'

const mobile = () => {
    const userAgent = navigator.userAgent;
    const mobileKeywords = ['Android', 'iPhone', 'iPad', 'Windows Phone', 'Mobile'];
    // Comprueba si alguno de los términos clave de dispositivos móviles está presente en el agente de usuario
    const isMobileDevice = mobileKeywords.some(keyword => userAgent.includes(keyword));

    return isMobileDevice;
}

export default mobile

